<div class="campaign-banner" (click)="redirectUrl(content)">
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
          <div class="campaign-video-container" >
            <image-manipulation [assetName]="data.name" [img]="showImg" [params]="assetImgParam"></image-manipulation>
            <!-- <div class="campaign-banner-gif">
              <img src="{{showImg}}" />
            </div> -->
          </div>

        <!-- <div class="campaign-video-container" (mouseenter)="playsVideoOnHover(data)"
          (mouseleave)="stopVideoOnHover()">
          <image-manipulation [assetName]="data.name" [img]="showImg" [params]="assetImgParam"></image-manipulation>

          <div class="campaign-banner-video" [hidden]="!videoPlayUrl"
            *ngIf="data?.campaign_banners[0]?.view_video_on_hover === '1' && data?.campaign_banners[0]?.video">
            <video [id]="'hoverVideo' + data.category_mongo_id" class="video-js vjs-fluid  vjs-16-9" autoplay
              preload="auto" playsinline>

            </video>
          </div>

        </div> -->

      </div>
    </div>
  </div>
</div>

<!-- Cancel subscription -->
<ng-template #content let-modal>
  <app-login-register></app-login-register>
</ng-template>